"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Label = _interopRequireDefault(require("../Label"));
var _FieldHelperText = _interopRequireDefault(require("../FieldHelperText"));
var _excluded = ["id", "label", "helperText", "error", "success", "required", "containerClassName"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var withFormField = function withFormField(_ref) {
  var messagePosition = _ref.messagePosition;
  return function (FieldComponent) {
    var FormField = function FormField(props) {
      var id = props.id,
        label = props.label,
        helperText = props.helperText,
        error = props.error,
        success = props.success,
        required = props.required,
        containerClassName = props.containerClassName,
        otherProps = _objectWithoutProperties(props, _excluded);
      var msgType = error && 'error' || success && 'success' || 'default';
      var message = error || success || helperText;
      var helper = !!message && /*#__PURE__*/_react["default"].createElement(_FieldHelperText["default"], {
        type: msgType
      }, message);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClassName
      }, !!label && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
        inputId: id,
        label: label,
        error: !!error,
        success: !!success,
        required: required
      }), messagePosition === 'top' && helper, /*#__PURE__*/_react["default"].createElement(FieldComponent, _extends({
        id: id,
        error: !!error,
        success: !!success
      }, otherProps)), messagePosition === 'bottom' && helper);
    };
    FormField.propTypes = {
      id: _propTypes["default"].string.isRequired,
      containerClassName: _propTypes["default"].string,
      label: _propTypes["default"].string,
      helperText: _propTypes["default"].string,
      error: _propTypes["default"].string,
      success: _propTypes["default"].string,
      required: _propTypes["default"].bool,
      disabled: _propTypes["default"].bool,
      handleChange: _propTypes["default"].func,
      value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array]),
      defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array])
    };
    FormField.defaultProps = {
      value: undefined,
      handleChange: undefined,
      containerClassName: undefined,
      label: undefined,
      helperText: undefined,
      error: undefined,
      success: undefined,
      required: undefined,
      disabled: undefined,
      defaultValue: undefined
    };
    return FormField;
  };
};
withFormField.propTypes = {
  messagePosition: _propTypes["default"].string
};
withFormField.defaultProps = {
  messagePosition: 'bottom'
};
var _default = exports["default"] = withFormField;